import { render, staticRenderFns } from "./BaseCollapseSection.vue?vue&type=template&id=2042140e&scoped=true&"
import script from "./BaseCollapseSection.vue?vue&type=script&lang=js&"
export * from "./BaseCollapseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseCollapseSection.vue?vue&type=style&index=0&id=2042140e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042140e",
  null
  
)

export default component.exports